import { useMemo } from 'react'

import { type Clinic, getClinics } from '@snootsvet/shared/portal'

import { useRegion } from '@/customer/hooks/use-region'

/**
 * Returns the clinics in the current member's region. Used by
 * region-scoped clinic pickers so a member never sees a clinic
 * they can't book at.
 *
 * Memoised so the returned array is stable across re-renders,
 * keeping downstream `useEffect` / `useMemo` dependencies quiet.
 */
export function useRegionClinics(): Clinic[] {
  const region = useRegion()
  return useMemo(() => getClinics().filter((c) => c.region === region.id), [region.id])
}
